import { useTranslation } from 'react-i18next'

import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'

function FormButtonSubmit({
  Component = Button.Contained,
  height = BUTTON_HEIGHT_32,
  qaName = QA_NAME_SAVE_BTN,
  title = 'Modal.CreateBtnKey',
  translationParams,
  type = 'submit',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Component
      {...restProps}
      height={height}
      qaName={qaName}
      text={t(title, translationParams)}
      type={type}
    />
  )
}

export default FormButtonSubmit
